import { getApiKey, isVisManager } from './visManager'

export function getClientAndAPIKey() {
  const client = isVisManager() ? 'vis_manager' : 'visit_now'
  const apiKey = isVisManager() ? getApiKey() : null
  const apiKeyURLParam = apiKey ? `&api_key=${encodeURIComponent(apiKey)}` : ''
  return { client, apiKey, apiKeyURLParam }
}
